// import 'bootstrap/dist/css/bootstrap.css'

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
// import 'bootstrap'

export const masterBus = new Vue();

window.$ = window.jQuery = require('jquery');
require("jquery-ui/ui/widgets/draggable");
require("jquery-ui/ui/widgets/droppable");
require('jquery-ui-touch-punch');
require('imagesloaded');


Vue.config.productionTip = false



  new Vue({
      router,
      store,
      render: createEle => createEle(App)
  }).$mount('#app');
